import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
export const searchEventsAlerts = async (payload) => fetch("POST", qualifyUrl("/events/search"), payload);
export const bulkScheduleEventDefinitions = async (entityIds) => fetch("POST", qualifyUrl("/events/definitions/bulk_schedule"), { entity_ids: entityIds });
